'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _Modal = require('components/Modal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComingUp = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(ComingUp, _React$Component);

  function ComingUp(props) {
    (0, _classCallCheck3.default)(this, ComingUp);
    return (0, _possibleConstructorReturn3.default)(this, (ComingUp.__proto__ || (0, _getPrototypeOf2.default)(ComingUp)).call(this, props));
  }

  (0, _createClass3.default)(ComingUp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (document.getElementsByClassName("centralButton")[0]) {

        var timeToShow = 12000; //despues de que se muestren las dos capas de texto (6 por cada una de ellas) 

        setTimeout(function () {
          document.getElementsByClassName("centralButton")[0].classList.add('showMe');
        }.bind(this), timeToShow);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var strings = this.props.strings;


      console.log(this.props);

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 1500, transitionEnter: true, transitionEnterTimeout: 1500, transitionLeave: true, transitionLeaveTimeout: 1500 },
        _react2.default.createElement(
          _reactBodyClassname2.default,
          { className: 'comingup' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Modal.Modal, { isOpen: true, strings: strings }),
            _react2.default.createElement(
              'div',
              { className: 'centralButton' },
              _react2.default.createElement(
                _reactRouter.Link,
                { ref: 'projectLink', className: 'nextLink', to: "/" + this.context.project + "/" + this.props.currentLanguage + "/", draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: 'jumpToProject' },
                  _react2.default.createElement(
                    'span',
                    null,
                    strings.buttonContinue
                  ),
                  _react2.default.createElement('i', { className: 'icon-arrowright' })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return ComingUp;
}(_react2.default.Component), _class2.displayName = 'ComingUp', _class2.propTypes = {
  name: _react2.default.PropTypes.string
}, _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp)) || _class);
;

exports.default = (0, _translate2.default)('ComingUp')(ComingUp);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ComingUp/ComingUp.js
// module id = 813
// module chunks = 0